var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstBusinessPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.72327 5.33333H12.2788M5.88993 2L4.77882 5.33333L7.00104 11.7222L9.22327 5.33333L8.11216 2M7.34248 11.5903L12.3195 5.61786C12.4038 5.51664 12.446 5.46603 12.4621 5.40954C12.4763 5.35973 12.4763 5.30694 12.4621 5.25713C12.446 5.20064 12.4038 5.15003 12.3195 5.04881L9.91209 2.15992C9.8631 2.10114 9.83861 2.07174 9.80859 2.05061C9.78198 2.03189 9.7523 2.01799 9.72089 2.00954C9.68543 2 9.64717 2 9.57066 2H4.43143C4.35492 2 4.31666 2 4.2812 2.00954C4.24979 2.01799 4.22011 2.03189 4.1935 2.05061C4.16348 2.07174 4.13899 2.10114 4.09 2.15992L1.68259 5.04881C1.59825 5.15002 1.55607 5.20063 1.53995 5.25713C1.52574 5.30694 1.52574 5.35973 1.53995 5.40954C1.55607 5.46603 1.59824 5.51664 1.68259 5.61786L6.65961 11.5903C6.77687 11.731 6.83549 11.8013 6.90568 11.827C6.96727 11.8495 7.03482 11.8495 7.0964 11.827C7.1666 11.8013 7.22522 11.731 7.34248 11.5903Z",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstBusinessPickup);
export default __webpack_public_path__ + "ce2b345098ec2fa5eba40e6de6cdef79.svg";
export { ForwardRef as ReactComponent };